import { useEffect, useState } from "react";
import styled from "styled-components";



type IProps = {
  formTitle: string;
  formSrc: string;
};

export default function FormComponent({
  formTitle,
  formSrc
}: IProps) {
  const [title, setTitle] = useState(`Eratek | ${formTitle}`);

  useEffect(() => {
    document.title = title;
    setTitle(title);
  }, [title]);

  return (
    <FormContainer
      style={{}}
    >
      <iframe
        title={formTitle}
        width="100%"
        height="780px"
        src={formSrc}
        style={{
          border: "none",
          maxWidth: "100%",
          maxHeight: "100vh",
        }}
        allowFullScreen={true}
      ></iframe>
    </FormContainer>
  );
}

const FormContainer = styled.div`
  width: 90%;

  @media (min-width: 1024px) {
    width: 80%;
  }
`;